export default __webpack_public_path__ + "static/media/thirdPic.7a88f9f8.webp";